var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenanceCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19267",
    "data-name": "Group 19267",
    transform: "translate(0.028 0.274)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.028 -0.274)",
    fill: "#edf0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-date-range",
    "data-name": "Icon material-date-range",
    d: "M15.253,4.344h-.672V3H13.237V4.344H7.86V3H6.516V4.344H5.844A1.338,1.338,0,0,0,4.507,5.688L4.5,15.1a1.344,1.344,0,0,0,1.344,1.344h9.409A1.348,1.348,0,0,0,16.6,15.1V5.688A1.348,1.348,0,0,0,15.253,4.344Zm0,10.753H5.844V7.7h9.409Z",
    transform: "translate(4.283 5.702)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceCal);
export default __webpack_public_path__ + "static/media/maintenance-cal.505cc361997e26ba96054b148168483d.svg";
export { ForwardRef as ReactComponent };